import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../../core/_base/crud';
import { DeNghiMuaHang, HHModel, DeNghiMuaHangCT } from '../de-nghi-mua-hang-page-model/de-nghi-mua-hang-page.model';
import { List } from 'lodash';
const API_ROOT_URL = environment.ApiRoot + '/muahang';

@Injectable()
export class DeNghiMuaHangPageService {

	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});

	lastData$: BehaviorSubject<DeNghiMuaHang[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DeNghiMuaHang_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDetail(itemId): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Get_Detail?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getLSMuaHang(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Get_HistoryMuaHang?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getLSNhanHang(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Get_HistoryNhanHang?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getLSDuyet(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Get_HistoryApprove?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getMOQ(idhh: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/getMOQHH?idhh=${idhh}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getConfigDefaultPB(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/getConfigDefaultPB', { headers: httpHeaders });
	}
	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Delete?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	downloadTemplate(itemId: any): string {
		return API_ROOT_URL + `/DeNghiMuaHang_DownFileDK?idCtdn=${itemId}`;
	}
	listQLGMNCC(listIDHH: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/dungchung' + '/QLGM_NCC_List';
		return this.http.post<any>(url, listIDHH, { headers: httpHeaders });
	}
	exportFileExcel(Id): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(`${API_ROOT_URL}/DeNghiMuaHang_Export?Id=${Id}`, {
			headers: httpHeaders,
			responseType: 'blob' as 'json'
		});
	}
	/*---------------------------------------------------------------------- */


	/*-------------------------------POST Method---------------------------- */
	add(item: DeNghiMuaHang): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL + '/DeNghiMuaHang_Insert200803', item, { headers: httpHeaders });
	}
	addDetailList(item: List<DeNghiMuaHangCT>): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_InsertDetail200803', item, { headers: httpHeaders });
	}
	updateDetailList(item: List<DeNghiMuaHangCT>): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_UpdateDetail200803', item, { headers: httpHeaders });
	}
	addHH(item: HHModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/HH_Insert', item, { headers: httpHeaders });
	}
	updateWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL + '/DeNghiMuaHang_Update_With_Detail200803', item, { headers: httpHeaders });
	}
	checkCancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuDNMuaHang_Check_Cancel?id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Cancel?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	approveAll(data : any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL + '/DeNghiMuaHang_ApproveAll', data, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */


	/*------------------------------ Qui trình ----------------------------- */
	DuyetTungHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_TP_DuyetMua200803', item, { headers: httpHeaders });
	}
	XacNhanTungHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_XacNhanKeHoach', item, { headers: httpHeaders });
	}
	XacNhanTatCaHang(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/DeNghiMuaHang_XacNhanKeHoachAll', itemId, { headers: httpHeaders });
	}
	TPDuyet(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_TP_DuyetMua', item, { headers: httpHeaders });
	}
	GDKDuyet(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_GDK_Duyet', item, { headers: httpHeaders });
	}
	GDDuyet(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT>(API_ROOT_URL + '/DeNghiMuaHang_GD_Duyet', item, { headers: httpHeaders });
	}
	dongDeNghi(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHangCT[]>(API_ROOT_URL + '/DeNghiMuaHang_DongDeNghi', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
  getReferences(purchaseRequestId: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(`${API_ROOT_URL}/detail/${purchaseRequestId}/references`, {
      headers: httpHeaders
    });
  }
}
